// src/layouts/MainLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import PieDeWeb from '../Screens/PieDeWeb';
import './MainLayout.css';       

const MainLayout = () => (
  <div className="layout">
    <Navbar />
    <Outlet />
    <PieDeWeb /> 
  </div>
);

export default MainLayout;
